import { useEffect } from "react";
import { supabase, isSupabaseConfigured } from "../supabase-client";

export function useRealtimeScenarios(
  onChange: (payload: unknown) => void,
): void {
  useEffect(() => {
    if (!isSupabaseConfigured()) return;

    const channel = supabase
      .channel("scenarios")
      .on(
        "postgres_changes",
        { event: "*", schema: "public", table: "scenarios" },
        (payload) => {
          onChange(payload);
        },
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [onChange]);
}
